import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';
import { SocialProofBar } from '../../components/SocialProofBar';
import { TrustBadges } from '../../components/TrustBadges';
export function TaekwondoNearMeHeroInfo() {
  return <div className="flex flex-col items-start" data-id="element-3406">
      <div className="inline-block bg-storm-red text-white px-4 py-1.5 rounded-full text-sm font-bold uppercase tracking-wide mb-6" data-id="element-3407">
        Taekwondo Classes Near You
      </div>
      <div className="mb-8" data-id="element-3408">
        <SocialProofBar data-id="element-3409" />
      </div>
      <h1 className="text-5xl md:text-6xl text-white mb-6 leading-[1.1]" data-id="element-3410">
        Taekwondo Classes Near Me in Farmington Hills
      </h1>
      <p className="text-xl text-off-white mb-8 max-w-xl leading-relaxed" data-id="element-3411">
        Storm Taekwondo offers kids, adult, family, self-defense and competition
        classes for beginners and experienced students across Farmington Hills,
        Novi, Commerce, Walled Lake, Wixom, Livonia, Northville, Waterford,
        White Lake, Milford, West Bloomfield and nearby Southeast Michigan
        communities.
      </p>

      <ul className="flex flex-col gap-3 mb-10" data-id="element-3412">
        {['Olympic-style Taekwondo techniques', 'Practical self-defense fundamentals', 'Improved balance, coordination, and agility', 'Goal setting through the belt ranking system'].map((item, idx) => <li key={idx} className="flex items-center gap-3 text-white text-lg" data-id="element-3413">
            <CheckCircle2 className="w-6 h-6 text-storm-red shrink-0" data-id="element-3414" />
            <span data-id="element-3415">{item}</span>
          </li>)}
      </ul>

      <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto mb-10" data-id="element-3416">
        <Link to="/SignMeUp" className="btn-primary" data-id="element-3417">
          Find the Right Class or Program
        </Link>
        <a href="tel:517-220-0621" className="btn-secondary" data-id="element-3418">
          Call 517-220-0621
        </a>
      </div>
      <TrustBadges data-id="element-3419" />
    </div>;
}